import React, { FC, useState } from 'react';

import { Equipment } from '@app/api/models/equipment';
import { useFetchData, useApi } from '@app/hooks';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';

import { useColumns } from './columns';
import { QueryTable } from '../common/table/query-table';
import { ClearQRDialog } from './clear-qr-dialog';

const EquipmentsTable: FC = () => {
  const [showClearQRDialog, setShowQRDialog] = useState(false); 
  const [currentId, setCurrentId] = useState<string>();
  const canEdit = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF] });

  const columns = useColumns(canEdit, (id) => {
    setCurrentId(id);
    setShowQRDialog(true);
  });
  const api = useApi();
  const [fetchData] = useFetchData<Equipment>({ method: api.equipments.getEquipments });

  return (<QueryTable<Equipment>
    title="Оборудование"
    columns={columns}
    fetchData={fetchData}
    canDownload
  >
    <ClearQRDialog 
      open={showClearQRDialog}
      onClose={() => setShowQRDialog(false)}
      equipId={currentId}
    />
  </QueryTable>);
};

export default EquipmentsTable;
